import { render } from "./PasswordUpdate.vue?vue&type=template&id=255effba"
import script from "./PasswordUpdate.vue?vue&type=script&lang=js"
export * from "./PasswordUpdate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\babay\\Documents\\GitHub\\gosociali-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/views/PasswordUpdate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "255effba"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('255effba', __exports__)) {
    console.log('reload')
    api.reload('255effba', __exports__)
  }
  
  module.hot.accept("./PasswordUpdate.vue?vue&type=template&id=255effba", () => {
    console.log('re-render')
    api.rerender('255effba', render)
  })

}


export default __exports__